import { render, staticRenderFns } from "./new-position-table.component.vue?vue&type=template&id=5863e401&scoped=true"
import script from "./new-position-table.component.vue?vue&type=script&lang=js"
export * from "./new-position-table.component.vue?vue&type=script&lang=js"
import style0 from "./new-position-table.component.vue?vue&type=style&index=0&id=5863e401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863e401",
  null
  
)

export default component.exports